import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const opsLinks = {
  verificationNoContact: "/admin/verifications?status=no_contact_info",
  verificationDeliveryFailed: "/admin/verifications?status=email_delivery_failed",
};

export default function OperationsPage() {
  const [data, setData] = useState(null);
  useEffect(() => {
    const token = localStorage.getItem("coi_platform_token");
    api.get("/admin/operations", { headers: { Authorization: `Bearer ${token}` } }).then((r) => setData(r.data));
  }, []);
  return (
    <section data-testid="operations-page">
      <p className="text-xs font-bold uppercase tracking-[.18em] text-blue-700">Launch operations</p>
      <h1 className="mt-2 text-2xl font-semibold">Operations watchlist</h1>
      <p className="mt-2 text-sm text-slate-600">Review these exceptions daily during launch. Click a verification exception to open the filtered queue.</p>
      <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {Object.entries(data || {}).map(([label, value]) => {
          const href = opsLinks[label];
          const inner = (
            <>
              <p className="text-3xl font-bold text-amber-900">{value}</p>
              <p className="mt-1 text-sm capitalize text-amber-800">{label.replace(/([A-Z])/g, " $1")}</p>
            </>
          );
          if (href) {
            return (
              <Link className="block rounded-lg border border-amber-200 bg-amber-50 p-5 transition hover:border-amber-400 hover:bg-amber-100" data-testid={`operation-${label}`} key={label} to={href}>
                {inner}
                <p className="mt-2 text-xs font-semibold text-amber-700">Open filtered queue →</p>
              </Link>
            );
          }
          return (
            <div className="rounded-lg border border-amber-100 bg-amber-50 p-5" data-testid={`operation-${label}`} key={label}>
              {inner}
            </div>
          );
        })}
      </div>
    </section>
  );
}
